// Notificaciones de cruce (precio×media, media×media) — ver notifications.js
// para la lógica pura. `events` es un log acotado (máx. MAX_NOTIFICATION_EVENTS,
// más reciente primero); `lastContext`/`lastProcessedTime` son el cursor de
// dedup/anti-retroactivos, sólo tienen sentido mientras `enabled === true`
// (ver hooks/useEmaSmaNotifications.js).
export const MAX_NOTIFICATION_EVENTS = 50

export const DEFAULT_NOTIFICATIONS = {
  enabled: false,
  lastContext: null,
  lastProcessedTime: null,
  events: [],
}

// Estilo de línea + grosor por media (2026-08-12). Defaults sensatos (sólida,
// 2px): las medias guardadas antes de esta versión no traen estos campos, y
// deben pintar igual que siempre — ver LINE_STYLES/DEFAULT_LINE_WIDTH abajo.
export const LINE_STYLES = Object.freeze(['solid', 'dashed', 'dotted'])
export const DEFAULT_LINE_STYLE = 'solid'
export const DEFAULT_LINE_WIDTH = 2
export const MIN_LINE_WIDTH = 1
export const MAX_LINE_WIDTH = 4

export const SAFE_DEFAULTS = {
  mas: [],
  notifications: DEFAULT_NOTIFICATIONS,
}

export function resolveConfig(raw) {
  if (!raw || typeof raw !== 'object') return { ...SAFE_DEFAULTS, notifications: { ...DEFAULT_NOTIFICATIONS } }
  const mas = Array.isArray(raw.mas) ? raw.mas.map(ma => ({
    id: ma.id || `ma-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    type: ma.type === 'sma' ? 'sma' : 'ema',
    period: Number.isFinite(ma.period) ? Math.max(1, Math.min(500, Math.round(ma.period))) : 20,
    color: /^#[0-9a-fA-F]{6}$/.test(ma.color) ? ma.color : (ma.type === 'sma' ? '#ef4444' : '#f59e0b'),
    active: ma.active !== false,
    lineStyle: LINE_STYLES.includes(ma.lineStyle) ? ma.lineStyle : DEFAULT_LINE_STYLE,
    lineWidth: Number.isFinite(ma.lineWidth) ? Math.max(MIN_LINE_WIDTH, Math.min(MAX_LINE_WIDTH, Math.round(ma.lineWidth))) : DEFAULT_LINE_WIDTH,
  })) : []
  const rawNotif = raw.notifications && typeof raw.notifications === 'object' ? raw.notifications : {}
  const notifications = {
    enabled: rawNotif.enabled === true,
    lastContext: typeof rawNotif.lastContext === 'string' ? rawNotif.lastContext : null,
    lastProcessedTime: Number.isFinite(rawNotif.lastProcessedTime) ? rawNotif.lastProcessedTime : null,
    events: Array.isArray(rawNotif.events) ? rawNotif.events.slice(0, MAX_NOTIFICATION_EVENTS) : [],
  }
  return { mas, notifications }
}
